import { Component, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { Constants } from '../../../../constants/constants';
import { ReviewService } from '../../../../services/review.service';
import { LaborTypeEnum } from '../../../../models/enum';
import { LaborByLevel } from '../../../../models/LaborByLevel';

@Component({
  selector: 'app-sol-labor-by-level',
  imports: [
    CommonModule,
    MatTableModule,
    TranslatePipe,
    CurrencyPipe
  ],
  templateUrl: './sol-labor-by-level.component.html',
  styleUrl: './sol-labor-by-level.component.scss'
})
export class SolLaborByLevelComponent implements OnInit {
    laborByLevelDetails: LaborByLevel[] = [];
    listOfLevelsId: string[] = [];
    listOfLaborTypesObjectOnLevelId: Record<string, LaborByLevel[]> = {};
    displayedColumnsLabor:string[] = ['laborType','servicingOffice','standardRate','baseHours','adjustmentHours','hoursTotal','otpwr','costTotal'];
    checkDataExists: boolean = true;
    constants = Constants;

    constructor(private readonly reviewService: ReviewService){}

    ngOnInit(): void {
        this.getLaborByLevelDetails();
    }

        getLaborByLevelDetails(){
            this.laborByLevelDetails = [];
            this.listOfLevelsId = [];
            this.listOfLaborTypesObjectOnLevelId = {};
            const newCostReviewObject = this.reviewService.newCostReviewObject
                if(newCostReviewObject && newCostReviewObject?.laborByLevelDetails){
                    this.laborByLevelDetails = JSON.parse(JSON.stringify(newCostReviewObject?.laborByLevelDetails));
                    this.segragateDataOnTheBasisOfLevelId();
                } else {
                    this.checkDataExists = false;
                }

        }

        segragateDataOnTheBasisOfLevelId() {
            this.laborByLevelDetails.forEach((element: LaborByLevel, index: number) => {
                if(element.levelDescription){
                    const levelKey = `${element.levelDescription}${this.constants.UNDERSCORE}${element.levelID}`;
                    if(!this.listOfLevelsId.includes(levelKey)){
                        this.listOfLevelsId.push(levelKey);
                        this.listOfLaborTypesObjectOnLevelId[levelKey] = [];
                    }
                    element.laborType = this.laborTypeDisplayName(element.laborType);
                    this.listOfLaborTypesObjectOnLevelId[levelKey].push(element);   
                    if((index + this.constants.ONE) === this.laborByLevelDetails.length){
                        this.combineSummaryAndEstimateData();
                        this.calculateSum();
                    }
                }
            });
        }

        combineSummaryAndEstimateData(){
            let summaryData: LaborByLevel[] = [];
            let estimateData: LaborByLevel[] = [];
            let summarySectionName = this.constants.TASK_BY_LEVEL_SUMMARY_LABEL;
            let estimateSectionName = this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL;
            const remainingLevels: string[] = [];

            this.listOfLevelsId.forEach((level: string) => {
                const isSummary = level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL) || level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR);
                const isEstimate = level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL) || level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR);

                if(level.includes(this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR) || level.includes(this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR)){
                    summarySectionName = this.constants.TASK_BY_LEVEL_SUMMARY_LABEL_FR;
                    estimateSectionName = this.constants.TASK_BY_LEVEL_ESTIMATE_LEVEL_LABEL_FR;
                }

                if (isSummary) {
                    summaryData = [...summaryData, ...(this.listOfLaborTypesObjectOnLevelId[level] || [])];
                    delete this.listOfLaborTypesObjectOnLevelId[level];
                } else if (isEstimate) {
                    estimateData = [...estimateData, ...(this.listOfLaborTypesObjectOnLevelId[level] || [])];
                    delete this.listOfLaborTypesObjectOnLevelId[level];
                } else {
                    remainingLevels.push(level);
                }
            });

            this.listOfLevelsId = remainingLevels;
            this.listOfLevelsId.unshift(`${summarySectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`,`${estimateSectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`);
            this.listOfLaborTypesObjectOnLevelId[`${estimateSectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`] = estimateData;
            this.listOfLaborTypesObjectOnLevelId[`${summarySectionName}${this.constants.UNDERSCORE}${this.constants.ONE}`] = summaryData;
        }

    laborTypeDisplayName(laborType: string): string{
        switch(laborType){
            case LaborTypeEnum.PM:
                return this.constants.PROJECT_MANAGER;
            case LaborTypeEnum.ENG:
                return this.constants.ENGINEER;
            case LaborTypeEnum.Prog:
                return this.constants.PROGRAMMING;
            case LaborTypeEnum.Grap:
                return this.constants.GRAPHICS;
            case LaborTypeEnum.SPEC:
                return this.constants.SPECIALIST;
            case LaborTypeEnum.DDS:
            case LaborTypeEnum.Ddep:
                return this.constants.DIGITAL_DEPLOYMENT_SPECIALIST;
            case LaborTypeEnum.MECH:
                return this.constants.MECHANICAL;
            case LaborTypeEnum.ELEC:
                return this.constants.ELECTRICAL;
            default:
                return laborType;
        }
    }

    calculateSum(){
        this.listOfLevelsId.forEach((level: string) => {
            let totalBaseHours = this.constants.ZERO;
            let totalAdjustmentHours = this.constants.ZERO;
            let totalHoursTotal = this.constants.ZERO;
            let totalCostTotal = this.constants.ZERO;
            this.listOfLaborTypesObjectOnLevelId[level].forEach((element: LaborByLevel) => {
                totalBaseHours += element.baseHours;
                totalAdjustmentHours += element.adjustmentHours;
                totalHoursTotal += element.hoursTotal;
                totalCostTotal += element.costTotal;
            });
            let totalRow: LaborByLevel = new LaborByLevel();
            totalRow.laborType = this.constants.LABOR_BY_LEVEL_TOTALS_LABEL;
            totalRow.baseHours = totalBaseHours;
            totalRow.adjustmentHours = totalAdjustmentHours;
            totalRow.hoursTotal = totalHoursTotal;
            totalRow.costTotal = totalCostTotal;
            this.listOfLaborTypesObjectOnLevelId[level].push(totalRow);
        });
    }

    getLevelName(level: string): string {
        if(level){
            return level.split(this.constants.UNDERSCORE)[this.constants.ZERO];
        } 
        return this.constants.EMPTY_STRING;
        
    }

    isCheckDataExists(): boolean {
        return this.checkDataExists && this.listOfLevelsId.length > Constants.ZERO;
    }

 
}
